import { useTranslations } from 'next-intl';
import replaceContact from '../utils/replaceContact';
import { BsExclamationOctagonFill } from 'react-icons/bs';

export default function Fallback({
  layout = 'lg',
  reset = () => {},
}: {
  layout?: 'sm' | 'lg';
  reset?: () => void;
}) {
  const t = useTranslations('errors');
  if (layout === 'sm') {
    return (
      <div className='flex items-center justify-center gap-4 rounded-sm rounded-sm bg-brand-alt p-6 text-white'>
        <div className='text-xl'>
          <BsExclamationOctagonFill />
        </div>
        <p
          dangerouslySetInnerHTML={{
            __html: replaceContact(t('desc') + ' ' + t('ifIssuePersists')),
          }}
        ></p>
      </div>
    );
  }

  return (
    <>
      <h1 className='mb-8 block border-b-4 text-[#B2B2B2] border-brand pb-2 text-xl uppercase md:text-3xl'>
        {t('title')}
      </h1>
      <div className='mx-auto flex w-full max-w-[600px] flex-col items-center gap-8 rounded bg-brand-alt/80 p-8 font-semibold text-white sm:flex-row'>
        <div className='text-3xl'>
          <BsExclamationOctagonFill />
        </div>
        <div className='flex flex-col gap-4'>
          <p>{t('desc')}</p>
          <button
            className='rounded-sm border-2 border-black bg-brand px-4 py-2 text-center font-semibold uppercase text-dark transition-all hover:border-brand hover:bg-black hover:text-white'
            onClick={() => reset()}
          >
            {t('tryAgain')}
          </button>
          <p
            dangerouslySetInnerHTML={{
              __html: replaceContact(t('ifIssuePersists')),
            }}
          ></p>
        </div>
      </div>
    </>
  );
}
